import { MARGIN_TOP_STROKE, TRACK_HEIGHT } from '../constants.js';

export const getTrackSeparatorOffset = (index: number) =>
  index * TRACK_HEIGHT + MARGIN_TOP_STROKE;
